import React from 'react';

const ScriptWaiting = () => {
  return (
    <svg
      width="51"
      height="51"
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
    >
      <g id="Group">
        <g id="Group_2">
          <g id="Group_3" opacity="0.496">
            <path
              id="Vector"
              d="M2.48402 18.7794C1.88702 20.3374 1.52202 23.6954 1.50402 24.8274C1.43702 29.0634 2.21202 33.7494 5.50902 38.7374M9.71902 43.6024L10.509 44.2474C14.736 47.6174 20.206 49.4984 25.582 49.4984C29.1166 49.4983 32.607 48.7127 35.8008 47.1984C38.9946 45.6841 41.8119 43.4789 44.049 40.7424C47.479 36.5464 49.5 31.0984 49.5 25.1484C49.5 20.6274 48.027 16.0414 45.504 12.2514M41.047 7.25939C36.868 3.53739 31.133 1.39939 24.841 1.51839C21.146 1.58839 16.776 2.71739 13.981 4.46639"
              stroke="#BBBBBB"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              id="Vector_2"
              d="M36.5011 8.5H42.5011V2.5M8.50208 48.5V42.5H14.5021"
              stroke="#BBBBBB"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <path
            id="Vector_3"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3 13.9167L9.5 4V10.375C9.5 10.5629 9.57609 10.743 9.71153 10.8759C9.84698 11.0087 10.0307 11.0833 10.2222 11.0833H16L9.5 21V14.625C9.5 14.4371 9.42391 14.257 9.28847 14.1241C9.15302 13.9913 8.96932 13.9167 8.77778 13.9167H3Z"
            stroke="#BBBBBB"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          id="Vector_4"
          d="M10.6348 27.518C11.0667 30.7225 12.5256 33.7006 14.7928 36.006M32.7698 12.377C30.5459 11.1423 28.0434 10.4963 25.4998 10.5C24.1698 10.4995 22.8456 10.675 21.5618 11.022"
          stroke="#BBBBBB"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <g id="Vector_5">
          <path
            d="M18.4128 38.7217C20.5916 39.8917 23.0268 40.5023 25.4998 40.4987C33.7838 40.4987 40.4998 33.7827 40.4998 25.4987C40.4998 21.3327 38.8018 17.5637 36.0598 14.8457"
            stroke="url(#paint0_linear_9652_38376)"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-dasharray="1 3"
          />
          <path
            d="M18.4128 38.7217C20.5916 39.8917 23.0268 40.5023 25.4998 40.4987C33.7838 40.4987 40.4998 33.7827 40.4998 25.4987C40.4998 21.3327 38.8018 17.5637 36.0598 14.8457"
            stroke="#DEDEDE"
            stroke-opacity="0.6"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-dasharray="1 3"
          />
        </g>
        <path
          id="Vector_6"
          d="M34.5 15.5C35.6046 15.5 36.5 14.6046 36.5 13.5C36.5 12.3954 35.6046 11.5 34.5 11.5C33.3954 11.5 32.5 12.3954 32.5 13.5C32.5 14.6046 33.3954 15.5 34.5 15.5Z"
          stroke="#BBBBBB"
          stroke-width="2"
        />
        <path
          id="Vector_7"
          d="M16.5 39.5C17.6046 39.5 18.5 38.6046 18.5 37.5C18.5 36.3954 17.6046 35.5 16.5 35.5C15.3954 35.5 14.5 36.3954 14.5 37.5C14.5 38.6046 15.3954 39.5 16.5 39.5Z"
          stroke="#BBBBBB"
          stroke-width="2"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_9652_38376"
          x1="39.2955"
          y1="16.1545"
          x2="16.1711"
          y2="38.7581"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7F7F7" />
          <stop offset="0.44808" stopColor="#9F9F9F" />
          <stop offset="1" stopColor="#9E9E9E" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ScriptWaiting;
